export default __webpack_public_path__ + "static/media/linha-agricola-534x444.e8c8bb64.jpg";